// Types
import { ClickAndCollectDisplayOpeningHoursProps } from './ClickAndCollectDisplayOpeningHours.types';

// Config
import appConstants from '@constants/appConstants';

// Styles
import styles from './click-and-collect-display-opening-hours.scss';

const dayMap: {
  [key: string]: string;
} = {
  Mon: 'Monday',
  Tue: 'Tuesday',
  Wed: 'Wednesday',
  Thu: 'Thursday',
  Fri: 'Friday',
  Sat: 'Saturday',
  Sun: 'Sunday',
};

const formatHours = (hours?: string) => {
  if (!hours) {
    return null;
  }

  const splitHour = hours.split(':');
  const hourPart = parseInt(splitHour[0], 10);
  const hourIn12HrFormat = hourPart % 12 || 12;
  const formattedHour = `${hourIn12HrFormat}:${splitHour[1]}`;
  const suffix = hourPart >= 12 ? 'pm' : 'am';

  return `${formattedHour} ${suffix}`;
};
const getFormattedHours = ({ closingTime, openingTime }: { closingTime?: string; openingTime?: string }) =>
  `${openingTime} – ${closingTime}`;
const getLongFormDayAndHours = ({
  closingTime,
  dayOfWeek,
  openingTime,
}: {
  closingTime?: string;
  dayOfWeek?: string;
  openingTime?: string;
}) => {
  const day = dayMap[dayOfWeek || ''] ?? '';

  if (isStoreOpen({ closingTime, openingTime })) {
    const opening = formatHours(openingTime);
    const closing = formatHours(closingTime);
    return `Open on ${day}, ${opening} to ${closing}`;
  }

  return `Closed on ${day}`;
};
const getIsDesktop = () => !window.matchMedia(`(max-width: ${appConstants.DESKTOP_BREAKPOINT})`).matches;
const isStoreOpen = ({ closingTime, openingTime }: { closingTime?: string; openingTime?: string }) =>
  !(openingTime === '' || closingTime === '');

const ClickAndCollectDisplayOpeningHours = ({ openingHours }: ClickAndCollectDisplayOpeningHoursProps) => {
  const isDesktop = getIsDesktop();

  const renderOpeningHours = () =>
    openingHours.map((item) => {
      const { closingTime, dayOfWeek, openingTime } = item;

      const ariaHidden = isDesktop ? 'true' : 'false';
      const ariaLabel = isDesktop ? getLongFormDayAndHours({ dayOfWeek, openingTime, closingTime }) : '';
      const storeOpen = isStoreOpen({ closingTime, openingTime });

      return (
        <li key={dayOfWeek} aria-label={ariaLabel} className={styles.listItem}>
          <span aria-hidden={ariaHidden} className={styles.dayOfWeek}>
            {dayOfWeek}:
          </span>
          {storeOpen ? (
            <span aria-hidden={ariaHidden}>{getFormattedHours({ closingTime, openingTime })}</span>
          ) : (
            <span aria-hidden={ariaHidden} data-testid="click-collect-store-closed">
              Closed
            </span>
          )}
        </li>
      );
    });

  return (
    openingHours && (
      <div data-testid="click-collect-times">
        <ul aria-label="Opening Times" className={styles.list}>
          {renderOpeningHours()}
        </ul>
      </div>
    )
  );
};

export default ClickAndCollectDisplayOpeningHours;
